import React, { FC, SVGProps } from 'react'
import theme from 'theme'

type Props = SVGProps<SVGSVGElement> & {
  sx?: Record<string, unknown>
}

const OnyxAIPredictIcon: FC<Props> = ({ ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.84849 8.88318C4.47858 6.1764 8.27303 2 8.27303 2C2.2667 2.69909 -0.322877 10.389 4.55052 14.3504L4.5865 12.9343C5.52161 13.974 6.67259 14.0636 6.67259 14.0636C5.93526 13.4542 5.93526 12.0919 5.93526 12.0919C7.12216 13.4183 8.39887 12.9343 8.39887 12.9343C6.90625 12.4504 7.01413 10.9267 7.01413 10.9267C9.62164 11.3748 9.51381 13.2032 9.51381 13.2032C8.65059 15.7665 5.62944 15.1032 5.62944 15.1032C9.26207 17.3079 14.1534 15.2107 15.5383 11.3927C16.941 7.59257 15.0348 3.03948 11.3482 3.89995C11.2582 3.09336 12.1934 2.44802 12.1934 2.44802C10.0714 3.1292 10.2152 4.13294 10.2152 4.13294L9.47787 3.16498L9.6577 4.79615L9.20813 6.69618C9.63974 8.04059 10.4849 7.61038 11.0065 6.5528C14.1177 5.96124 12.8048 11.0161 8.84841 8.88309L8.84849 8.88318Z"
      fill={theme.colors.surfaceContainerBackground}
    />
  </svg>
)

export default OnyxAIPredictIcon
